export const participation = [
    {value: '0', label: "НЕТ, не участвую в закупках"},
    {value: '200000' , label: 'Не превышает 90 млн. руб.' },
    {value: '2500000', label: 'Не превышает 500 млн. руб.' },
    {value: '4500000' , label: 'Не превышает 3 млрд. руб.' },
    {value: '7000000', label: 'Не превышает 10 млрд. руб.' },
    {value: '25000000' , label: '10 млрд. руб. и более' },
   
];